var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"100px","position":"center","text-align":"right","color":"#dddd"}})}
var staticRenderFns = []

export { render, staticRenderFns }